let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2OUd3")).then(() => parcelRequire('821j5'));